import { ChangeDetectorRef, Component } from '@angular/core';
import { TreeSelectorComponent } from '../tree-selector/tree-selector.component';
import { ThreeGraphqlService } from '../../../../../../graphql/three/services/three-graphql.service';
import { CanvasControllerService } from '../../../../../../services/canvas-controller/canvas-controller.service';
import { MatIconModule } from '@angular/material/icon';
interface Sticker {
  id: string;
  name: string;
  category: string;
  thumbnail: string;
  description: string;
  size: string;
}

@Component({
  selector: 'livery-tool',

  imports: [TreeSelectorComponent, MatIconModule],

  templateUrl: './livery-tool.component.html',
  styleUrl: './livery-tool.component.scss',
  standalone: true,
})
export class LiveryToolComponent {
  constructor(
    private threeGraphqlService: ThreeGraphqlService,
    private canvasController: CanvasControllerService,
    private cd: ChangeDetectorRef,
  ) {}

  uploadedImage: string | null = null;
  selectedSticker: Sticker | null = null;
  selectedMaterialNames: string[] = [];

  changeSelectedMaterials(materialNames: string[]): void {
    this.selectedMaterialNames = materialNames;
    console.log('Selected materials:', this.selectedMaterialNames);
  }

  onUploadClick(): void {
    console.log('Upload clicked');
  }

  onFileSelected(event: any): void {
    // 파일 선택 이벤트
    const file = event.target.files[0];
    if (file) {
      this.threeGraphqlService.uploadImage(file).subscribe((imageUrl: string) => {
        this.uploadedImage = imageUrl;
        this.canvasController.materialsImageChange(this.selectedMaterialNames, imageUrl);
        this.cd.markForCheck();
      });
    }
  }

  removeImage(): void {
    this.uploadedImage = null;
    this.canvasController.materialsImageChange(this.selectedMaterialNames, '');
    this.cd.markForCheck();
  }
}
